// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import { generateId, mobileView } from '../../../_common/api/utility';
import Title from '../../../_common/form/Title';
import { useGlobalState } from '../../../_common/globalState/GlobalStateProvider';
import Page from '../../pageLayout/Page';
import Bundles from './Bundles';
import Cards from './Cards';
import Clubs from './Clubs';
import Washes from './Washes';
import Merchandise from './Merchandise';

const Row = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;

    ${({ mobile }) => mobile && `
        flex-wrap: wrap;
    `}
`

const SelectableButton = styled(Link)`
    padding: 0 1em;
    text-decoration: none;
    color: ${({ theme }) => theme.text};
    border-radius: 5rem;
    flex-grow: 1;
    margin: 0 1em;
    text-align: center;
    border:1px solid  ${({ theme }) => theme.secondary};
    transition: all 0.2s;

    ${({ theme, selected }) => selected ? `
        background: ${theme.secondary};
        color: ${theme.active};
        font-weight: bold;
    ` : null}


    ${({ mobile }) => mobile && `
        margin: 0.5em 1em;
    `}
`


const ShopRouter = ({ children }) => {
    const { state: {
        site_config,
        // mobileView
    } } = useGlobalState();

    const getPath = tag => site_config.shopItems.find(e => e.tag === tag)?.href;

    const current = site_config.shopItems.findIndex(e => window.location.pathname.includes(e.href));

    const [selected, setSelected] = useState(current !== -1 ? current : 0);

    return (
        <Page>
            <Title icon='basket'>Shop - {site_config.shopItems[selected].label}</Title>
            <Row mobile={mobileView ? 1 : 0}>
                {site_config.shopItems.filter(e => e.label).map((e, i) =>
                    <SelectableButton
                        key={`ShotButton-${i}`}
                        to={getPath(e.tag)}
                        selected={i === selected}
                        onClick={() => setSelected(i)}
                        mobile={mobileView ? 1 : 0}
                    >{e.label}</SelectableButton>)}
            </Row>

            <Routes>
                <Route path={'*' || getPath('_WASHES')} element={<Washes />} />
                <Route path={getPath('_CLUBS')} element={<Clubs />} />
                <Route path={getPath('_BUNDLES')} element={<Bundles />} />
                <Route path={getPath('_CARDS')} element={<Cards />} />
                <Route path={getPath('_MERCH')} element={<Merchandise />} />
            </Routes>
        </Page>
    );
}

export default ShopRouter;
